import React, { useState, useEffect, useRef } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { StudentAd2Card } from "./ad2Card";
import { AD2_CONSTANTS } from "./ad2Constants";
import { EmployabilitySpeedometer } from "./employabilitySpeedometer";
import Loader from "../../components/loader/loader";
import { NotCompleteText } from "./commonStyles";
import { useDispatch } from "react-redux";
import html2canvas from "html2canvas";
import { updateImageBase } from "./imageReducer";
export function Ad2EmployabilityFactors({data, onViewMoreClick}) {
  const chartData = data;
  
  const status = chartData && chartData.status;
  const total = chartData && chartData.totalScore;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const cardsData = [
    {
      title: t("Ideas & Opportunities"),
      description: t(AD2_CONSTANTS.IDEAS_AND_OPPORTUNITIES_DESCRIPTION),
      value:
        chartData &&
        chartData?.["domains"]?.["Ideas and Opportunities"] &&
        chartData?.["domains"]?.["Ideas and Opportunities"]?.points,
    },
    {
      title: t("Resources"),
      description: t(AD2_CONSTANTS.RESOURCES_DESCRIPTION),
      value:
        chartData &&
        chartData?.["domains"]?.["Resources"] &&
        chartData?.["domains"]?.["Resources"]?.points,
    },
    {
      title: t("Into Action"),
      description: t(AD2_CONSTANTS.INTO_ACTION_DESCRIPTION),
      value:
        chartData &&
        chartData?.["domains"]?.["Into Action"] &&
        chartData?.["domains"]?.["Into Action"]?.points,
    },
  ];
      const chartRef = useRef(null);
      const chartRef2 = useRef(null);
      const chartRef3 = useRef(null);

      const refList = [chartRef,chartRef2,chartRef3]
      useEffect(() => {
    if (data && data.domains) {
      setTimeout(() => {
        refList.forEach((ref,index)=>{
              html2canvas(ref.current,{
                 backgroundColor: null,
  scale: 2, // higher resolution
  removeContainer: true,
              }).then((canvas) => {
                  const ctx = canvas.getContext("2d");
  const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let top = null, bottom = null, left = null, right = null;

  for (let y = 0; y < imgData.height; y++) {
    for (let x = 0; x < imgData.width; x++) {
      const alpha = imgData.data[(y * imgData.width + x) * 4 + 3];
      if (alpha > 0) {
        if (top === null) top = y;
        bottom = y;
        if (left === null || x < left) left = x;
        if (right === null || x > right) right = x;
      }
    }
  }
        const trimmed = ctx.getImageData(left, top, right - left, bottom - top);
          const newCanvas = document.createElement("canvas");
          newCanvas.width = right - left;
          newCanvas.height = bottom - top;
          newCanvas.getContext("2d").putImageData(trimmed, 0, 0);

            dispatch(updateImageBase({name:`employability${index + 1}`,value:newCanvas.toDataURL("image/png")}))
        });
        })
      
      }, 500); 
    }
  }, [data]);
  return (
    <>
      {chartData?.thisEmpty === true ? 
    <NotCompleteText style={{textAlign:"center"}}>{t('Not Completed')}</NotCompleteText>
    : chartData?.["domains"]?.["Resources"]?.points && chartData?.["domains"]?.["Resources"]?.points ? (
        <StudentAd2Card
          title={t("Employability")}
          data={chartData}
          status={status}
          onViewMoreClick={onViewMoreClick}
        >
          {cardsData.map((item, index) => (
            <Col md="4" key={index}>
              <div ref={refList[index]}>
              <EmployabilitySpeedometer {...item} />

              </div>
            </Col>
          ))}
        </StudentAd2Card>
        ) : ( 
        <Loader></Loader> 
      )} 
    </>
  );
}
